import infoIcon from "@/assets/img/icon-info.png";
import infoWarnIcon from "@/assets/img/icon-info-warn.png";
import heartIcon from "@/assets/img/icon-heart.png";

const MobileNotify = {};

MobileNotify.install = (Vue) => {
    Vue.prototype.$toast = {
        success(message, duration = 3000) {
            Vue.notify({
                group: "main",
                text: message,
                speed: 700,
                duration: duration,
                data: { icon: heartIcon },
            });
        },
        error(message, duration = 3000) {
            Vue.notify({
                group: "main",
                text: message,
                speed: 700,
                duration: duration,
                data: { icon: infoWarnIcon },
            });
        },
        warning(message, duration = 3000) {
            Vue.notify({
                group: "main",
                text: message,
                speed: 700,
                duration: duration,
                data: { icon: infoIcon },
            });
        },
    };
};

export default MobileNotify;
